import React, { useState, useEffect } from "react";
import { Box, Dialog, Typography } from "@mui/material";
import { getTokenbyData, getUserById } from "../../services/user.service";
import EditProfileUser from "../User/EditUserProfile";
import {
  getAdminDashBoard,
  getClientDashBoard,
} from "../../services/dashboard.service";
import { getPublicHoliday } from "../../services/publicHoliday.service";
import moment from "moment";
import ChangePassword from "../User/ChangePassword";
import CommonLoader from "../../common/CommonLoader/CommonLoader";
import dayjs from "dayjs";
import NoPhotographyIcon from "@mui/icons-material/NoPhotography";
import CloseIcon from "@mui/icons-material/Close";
import { encryptData } from "../../utils/cryptoUtils";
import { jwtDecode } from "jwt-decode";
import { useAuth } from "../../context/AuthProvider";
import {
  AdminDashboard,
  ClientDashboard,
  EmployeeDashboard,
} from "./components";

const Dashboard = () => {
  const { accessToken } = useAuth();
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openCPDrawer, setOpenCPDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [data, setData] = useState([]);
  const [adminData, setAdminData] = useState([]);
  const [allHolidays, setAllHolidays] = useState([]);
  const [clientData, setClientData] = useState([]);
  const [who, setWho] = useState(null);
  const [client, setClient] = useState(null);
  const [openLoader, setOpenLoader] = useState(true);
  const [isEmployeeLoading, setIsEmployeeLoading] = useState(false);

  const [selectedImage, setSelectedImage] = useState("");
  const [openImageDialog, setOpenImageDialog] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const isMenuOpen = Boolean(anchorEl);
  const currentDate = dayjs();
  const [queryParam, setQueryParam] = useState({
    month: currentDate.month() + 1,
    year: currentDate.year(),
  });

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleDateChange = (newValue) => {
    setSelectedDate(newValue);
    handleMenuClose();

    setQueryParam((prevQueryParam) => ({
      ...prevQueryParam,
      month: newValue.month() + 1, // month() returns 0-based month, so add 1
      year: newValue.year() || prevQueryParam.year,
    }));
  };

  //decodeToken
  const getUserIdFromToken = () => {
    if (!accessToken) return null;
    try {
      const decoded = jwtDecode(accessToken);
      return decoded.id;
    } catch (error) {
      console.error("Invalid token", error);
      return null;
    }
  };

  // Navigate To TaskManagement Production Filed
  const productionStatus = {
    "To Do": false,
    InProgress: false,
    QA: false,
    Completed: false,
    Production: true,
  };

  const userId = getUserIdFromToken();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getTokenbyData();
        console.log("ressss", res);
        const usersData = res.data;
        const isAdmin = usersData?.isOverAllAdmin || false;
        const isClient = usersData?.isClient || false;
        setClient(isClient);
        setWho(isAdmin);
        if (isAdmin) {
          await getAdminData(queryParam);
        } else if (isClient) {
          await getClientData(queryParam);
        } else if (!isAdmin) {
          await getUserData(userId, queryParam);
        }
        setOpenLoader(false);
      } catch (error) {
        console.error("Error fetching role data:", error);
      }
    };

    fetchData();
  }, [userId, queryParam.month, queryParam.year]);

  const getAdminData = async () => {
    try {
      const encryptedMonth = encryptData(queryParam.month.toString());
      const encryptedYear = encryptData(queryParam.year.toString());

      const queryParams = {
        month: encryptedMonth,
        year: encryptedYear,
      };
      const res = await getAdminDashBoard(queryParams);
      setAdminData(res.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getClientData = async () => {
    try {
      const id = getUserIdFromToken();
      const encryptedMonth = encryptData(queryParam.month.toString());
      const encryptedYear = encryptData(queryParam.year.toString());

      const queryParams = {
        month: encryptedMonth,
        year: encryptedYear,
      };
      const res = await getClientDashBoard(id, queryParams);
      setClientData(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const fetchAllHolidays = async () => {
      try {
        const encryptedYear = encryptData(queryParam.year.toString());
        const res = await getPublicHoliday({ year: encryptedYear });
        if (res?.data?.data) {
          setAllHolidays(res.data.data);
        }
      } catch (error) {
        console.error("Error fetching holidays:", error);
      }
    };
    fetchAllHolidays();
  }, [queryParam.year]);

  const employeeProject = (data?.projectTask || []).map((eve) => ({
    id: eve.projectName,
    value: eve.projectName,
  }));

  const [selectedProject, setSelectedProject] = useState(
    employeeProject.length > 0 ? employeeProject[0] : null
  );

  useEffect(() => {
    if (employeeProject.length > 0 && selectedProject === null) {
      setSelectedProject(employeeProject[0]);
    }
  }, [employeeProject, selectedProject]);

  const clientProject = (clientData?.projectTask || []).map((eve) => ({
    id: eve.projectName,
    value: eve.projectName,
  }));

  const [selectedClientProject, setSelectedClientProject] = useState(
    clientProject.length > 0 ? clientProject[0] : null
  );

  useEffect(() => {
    if (clientProject.length > 0 && selectedClientProject === null) {
      setSelectedClientProject(clientProject[0]);
    }
  }, [clientProject, selectedClientProject]);

  const getUserData = async (userId) => {
    setIsEmployeeLoading(true);
    try {
      const encryptedMonth = encryptData(queryParam.month.toString());
      const encryptedYear = encryptData(queryParam.year.toString());
      const queryParams = {
        month: encryptedMonth,
        year: encryptedYear,
      };
      const res = await getUserById(userId, queryParams);
      const userData = res.data.data;

      if (userData.dateOfBirth) {
        userData.dateOfBirth = moment(userData.dateOfBirth).format(
          "DD-MM-YYYY"
        );
        if (userData.joiningDate) {
          userData.joiningDate = moment(userData.joiningDate).format(
            "DD/MM/YYYY"
          );
        }
      }
      setData(userData);
    } catch (error) {
      console.log(error);
    } finally {
      setIsEmployeeLoading(false);
    }
  };

  if (openLoader) {
    return (
      <Typography>
        <CommonLoader />
      </Typography>
    );
  }

  const currentAddress = data?.address?.currentAddress ?? {};
  const doorNo_street = currentAddress.doorNo_street ?? "";
  const place = currentAddress.place ?? "";
  const district = currentAddress.district ?? "";
  const pincode = currentAddress.pincode ?? "";

  const emergencyDetails = data?.emergencyDetails ?? {};
  const emgName = emergencyDetails?.name ?? "";
  const emgRelation = emergencyDetails?.relation ?? "";
  const emgMobile = emergencyDetails?.mobileNo ?? "";

  const annualAvaLeave = data?.availableLeave?.annualLeave ?? 0;
  const sickAvaLeave = data?.availableLeave?.sickLeave ?? 0;
  const unPaidAvaLeave = data?.availableLeave?.unpaidLeave ?? 0;
  const annualTakenLeave = data?.leaveTaken?.annualLeave ?? 0;
  const sickTakenLeave = data?.leaveTaken?.sickLeave ?? 0;
  const unPaidTakenLeave = data?.leaveTaken?.unpaidLeave ?? 0;

  const employeeDetails = data?.employeeDetails ?? {};
  const employeeDepartment = employeeDetails?.employeeDepartment ?? "";
  const employeeRole = employeeDetails?.employeeRole ?? "";
  const employeeStatus = employeeDetails?.employeeStatus ?? "";
  const employeeType = employeeDetails?.employeeType ?? "";

  const handleEdit = () => {
    setOpenDrawer(true);
    setSelectedData({ data });
  };

  const handleChangePassword = () => {
    setOpenCPDrawer(true);
  };

  const renderFile = (file) => {
    if (!file?.location) {
      return <NoPhotographyIcon />;
    }
    return (
      <img
        src={file.location}
        alt={file.fileName || "No Profile"}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          cursor: "pointer",
        }}
        onClick={() => handleImageClick(file.location)}
      />
    );
  };

  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl);
    setOpenImageDialog(true);
  };

  return (
    <>
      <Box sx={{ maxHeight: "100vh" }} className="no-scrollbar">
        {who === true ? (
          <AdminDashboard
            adminData={adminData}
            handleDateChange={handleDateChange}
            handleMenuClick={handleMenuClick}
            handleMenuClose={handleMenuClose}
            isMenuOpen={isMenuOpen}
            anchorEl={anchorEl}
            selectedDate={selectedDate}
            renderFile={renderFile}
            who={who}
            productionStatus={productionStatus}
            allHolidays={allHolidays}
          />
        ) : client === true ? (
          <ClientDashboard
            clientData={clientData}
            handleDateChange={handleDateChange}
            handleMenuClick={handleMenuClick}
            handleMenuClose={handleMenuClose}
            isMenuOpen={isMenuOpen}
            anchorEl={anchorEl}
            selectedDate={selectedDate}
            clientProject={clientProject}
            selectedClientProject={selectedClientProject}
            setSelectedClientProject={setSelectedClientProject}
          />
        ) : (
          <EmployeeDashboard
            data={data}
            handleEdit={handleEdit}

            handleChangePassword={handleChangePassword}
            renderFile={renderFile}
            employeeProject={employeeProject}
            selectedProject={selectedProject}
            setSelectedProject={setSelectedProject}
            emgName={emgName}
            emgRelation={emgRelation}
            emgMobile={emgMobile}
            doorNo_street={doorNo_street}
            place={place}
            district={district}
            pincode={pincode}
            annualAvaLeave={annualAvaLeave}
            sickAvaLeave={sickAvaLeave}
            unPaidAvaLeave={unPaidAvaLeave}
            annualTakenLeave={annualTakenLeave}
            sickTakenLeave={sickTakenLeave}
            unPaidTakenLeave={unPaidTakenLeave}
            employeeDepartment={employeeDepartment}
            employeeRole={employeeRole}
            employeeStatus={employeeStatus}
            employeeType={employeeType}
            who={who}
            adminData={adminData}
            handleDateChange={handleDateChange}
            handleMenuClick={handleMenuClick}
            handleMenuClose={handleMenuClose}
            isMenuOpen={isMenuOpen}
            anchorEl={anchorEl}
            selectedDate={selectedDate}
            productionStatus={productionStatus}
            allHolidays={allHolidays}
            isEmployeeLoading={isEmployeeLoading}
          />
        )}
      </Box>
      <Dialog
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        sx={{
          "& .MuiDialog-paper": {
            width: "100%",
            maxWidth: "800px",
            borderRadius: "10px",
          },
        }}
      >
        <EditProfileUser
          onClose={() => setOpenDrawer(false)}
          data={selectedData}
          getData={getUserData}
        />
      </Dialog>
      <Dialog
        open={openCPDrawer}
        onClose={() => setOpenCPDrawer(false)}
        sx={{
          "& .MuiDialog-paper": {
            width: "100%",
            maxWidth: "500px",
            borderRadius: "10px",
          },
        }}
      >
        <ChangePassword onClose={() => setOpenCPDrawer(false)} />
      </Dialog>
      <Dialog
        open={openImageDialog}
        onClose={() => setOpenImageDialog(false)}
        PaperProps={{
          style: {
            width: "500px",
            height: "500px",
            overflow: "hidden",
            position: "relative",
          },
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "5px",
            right: "5px",
            cursor: "pointer",
            zIndex: 999,
          }}
          onClick={() => setOpenImageDialog(false)}
        >
          <CloseIcon />
        </Box>
        <img
          src={selectedImage}
          alt="profile"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      </Dialog>
    </>
  );
};

export default Dashboard;
